import { SearchQueryTermsStateResult, useSearchState } from './use-search-state';

export function useSearchQueryTermsState(namespace: string): SearchQueryTermsStateResult {
  const { compoundNamespace, loading, mode, searchQueryTerms, textFilter } =
    useSearchState(namespace);

  return {
    compoundNamespace,
    searchQueryTerms,
    textFilter,
    loading,
    mode,
  };
}
